import { z } from 'zod';

import { applicationDateOrder, idArray, paymentReportsFilterSchema, transactionDateOrder } from './shared.schema';

export const rateTypeSchema = z.enum([
	'Monthly',
	'Validation',
	'Hotel Storage',
	'Office/Retail Rent',
	'Miscellaneous',
	'Applied Credit',
	'Carryover',
]);

export const paymentSummaryRateTypes = rateTypeSchema.options;

export const paymentSummaryReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

const dateOrderSchema = z.discriminatedUnion('dateOrder', [transactionDateOrder, applicationDateOrder]);

const commonFields = z.object({
	accountFilter: paymentReportsFilterSchema.optional(),
	rateTypes: z.array(rateTypeSchema).min(1),
	areaIds: idArray.optional(),
	branchIds: idArray.optional(),
	districtIds: idArray.optional(),
	organizationIds: idArray.optional(),
	facilityIds: z.array(z.string()).optional(),
	format: paymentSummaryReportFormatSchema.default('csv'),
	facilityNumber: z.union([z.string(), z.number()]).optional(),
});

export const paymentSummaryParametersSchema = z
	.intersection(commonFields, dateOrderSchema)
	.superRefine((value, ctx) => {
		if (value.dateOrder === 'transactionDate' && value.applicationEndDate && !value.applicationStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['applicationEndDate'],
				message: 'Cannot specify an Application End Date without an Application Start Date',
			});
		}

		if (value.dateOrder === 'applicationDate' && value.transactionEndDate && !value.transactionStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['transactionEndDate'],
				message: 'Cannot specify a Transaction End Date without a Transaction Start Date',
			});
		}
	});

export type PaymentSummaryRateType = z.infer<typeof rateTypeSchema>;
export type PaymentSummaryParameters = z.infer<typeof paymentSummaryParametersSchema>;
export type PaymentSummaryReportFormat = z.infer<typeof paymentSummaryReportFormatSchema>;
